import { render, staticRenderFns } from "./components-template.vue?vue&type=template&id=2842794c"
import script from "./components-template.vue?vue&type=script&lang=js"
export * from "./components-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports